<template>
    <div class="cursus-tabs nav mb-3">
        <div class="nav-item d-none d-md-block">
            <a href="#" class="nav-link" :class="{ 'active': !value.year }" @click.prevent="handleChanged(null)">
                <div class="row mx-n1">
                    <div class="col-auto px-1">
                        <Icon name="arrow-down" width=".75em" height=".75em" class="fill-current align-baseline ml-2" />
                    </div>
                    <div class="col px-1">
                        {{ futureLabel }}
                    </div>
                </div>
            </a>
        </div>
        <div class="nav-item nav-link ml-3 mr-n2 d-none d-md-block">
            Archives :
        </div>
        <template v-if="hasYears">
            <template v-for="year in criterias.years">
                <div class="nav-item d-none d-md-block">
                    <a href="#" class="nav-link" :class="{ 'active': isActive(year) }" @click.prevent="handleChanged(year)">
                        <div class="row mx-n1">
                            <div class="col-auto px-1">
                                <Icon name="arrow-down" width=".75em" height=".75em" class="fill-current align-baseline ml-2" />
                            </div>
                            <div class="col px-1">
                                {{ label(year) }}
                            </div>
                        </div>
                    </a>
                </div>
            </template>

            <div class="nav-item d-md-none">
                <b-form-select
                    class="custom-select bg-white border-0 h-100 w-auto agency-title-font"
                    :value="currentYear"
                    @change="handleChanged"
                >
                    <option :value="null">{{ futureLabel }}</option>
                    <template v-for="year in criterias.years">
                        <option :value="year">{{ label(year) }}</option>
                    </template>
                </b-form-select>
            </div>
        </template>
    </div>
</template>

<script>
    import { BFormSelect } from 'bootstrap-vue';
    import Icon from "../ui/Icon.vue";

    export default {
        components: {
            BFormSelect,
            Icon,
        },
        props: {
            criterias: Object,
            value: Object,
            futureLabel: {
                type: String,
                default: 'À venir',
            }
        },
        computed: {
            currentYear() {
               return this.value.year || null;
            },
            hasYears() {
                return this.criterias.years?.length > 0;
            },
        },
        methods: {
            handleChanged(year) {
                this.$emit('input', {
                    ...this.value,
                    year: year || undefined,
                });
            },
            isActive(year) {
                return this.value.year == year;
            },
            label(year) {
                // if(this.criterias.years?.length === 1) {
                //     return 'Passé';
                // }
                return year;
            },
        }
    }
</script>
